import { IS_BROWSER } from '@web/libs/constants'
import { langVar } from '@web/libs/translate/translate.state'

import { useGlobalStaticStateContext } from './useGlobalStaticState'

const mobileClassName = 'place_on_mobileweb'
const pcClassName = 'place_on_pc'
const englishClassName = 'place_lang_en'

const toggleBodyClass = ({ on, className }: { on: boolean; className: string }) => {
  if (!IS_BROWSER) return

  if (on) document.body.classList.add(className)
  else document.body.classList.remove(className)
}

const useGlobalBodyClass = () => {
  const { isMobile } = useGlobalStaticStateContext()
  toggleBodyClass({ on: isMobile, className: mobileClassName })
  toggleBodyClass({ on: !isMobile, className: pcClassName })

  const isEnglish = langVar() === 'en'
  toggleBodyClass({ on: isEnglish, className: englishClassName })
}

export default useGlobalBodyClass
